import { render, staticRenderFns } from "./EditFaturaextratoPage.vue?vue&type=template&id=00ee25c5"
import script from "./EditFaturaextratoPage.vue?vue&type=script&lang=js"
export * from "./EditFaturaextratoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports